module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    class: [
      'yu-icon',
      'yu-ico-' + (_vm.active ? _vm.onName : _vm.name),
      {
        'i-active': _vm.active
      }
    ],
    attrs: {
      "data-com": "YuIcon"
    }
  }, [_c('use', {
    attrs: {
      "xlink:href": '#yu-ico-' + (_vm.active ? _vm.onName : _vm.name)
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f6e71958","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/base/YouUI/Icon/Icon.vue
// module id = 297
// module chunks = 0